import * as React from "react";
import type { SVGProps } from "react";
const SvgStopwatch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M28.561 5.786v4.176h-1.75V5.786h1.75ZM11.89 11.24l1.391 2.11 1.461-.963-1.391-2.11-1.461.963ZM43.484 11.24l-1.391 2.11-1.461-.963 1.391-2.11 1.461.963Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M14.267 5.105a2 2 0 0 0-2.77-.568L7.448 7.206a2 2 0 0 0-.568 2.77l1.277 1.937a2 2 0 0 0 2.77.568l4.047-2.668a2 2 0 0 0 .57-2.771l-1.278-1.937Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m8.413 8.666 4.047-2.668a.25.25 0 0 1 .346.07l1.277 1.937a.25.25 0 0 1-.07.347L9.964 11.02a.25.25 0 0 1-.346-.07L8.342 9.012a.25.25 0 0 1 .07-.347Zm3.083-4.13a2 2 0 0 1 2.771.57l1.277 1.936a2 2 0 0 1-.569 2.77l-4.046 2.67a2 2 0 0 1-2.771-.57L6.88 9.977a2 2 0 0 1 .568-2.77l4.047-2.67Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M21.407 2a2 2 0 0 1 2-2h8.56a2 2 0 0 1 2 2v2.72a2 2 0 0 1-2 2h-8.56a2 2 0 0 1-2-2V2Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M31.967 1.75h-8.56a.25.25 0 0 0-.25.25v2.72c0 .139.112.25.25.25h8.56a.25.25 0 0 0 .25-.25V2a.25.25 0 0 0-.25-.25ZM23.407 0a2 2 0 0 0-2 2v2.72a2 2 0 0 0 2 2h8.56a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-8.56Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M41.107 5.105a2 2 0 0 1 2.77-.568l4.048 2.669a2 2 0 0 1 .568 2.77l-1.277 1.937a2 2 0 0 1-2.77.568l-4.047-2.668a2 2 0 0 1-.57-2.771l1.278-1.937Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m46.961 8.666-4.047-2.668a.25.25 0 0 0-.346.07L41.29 8.006a.25.25 0 0 0 .07.347l4.048 2.668a.25.25 0 0 0 .346-.07l1.277-1.937a.25.25 0 0 0-.07-.347Zm-3.083-4.13a2 2 0 0 0-2.771.57L39.83 7.041a2 2 0 0 0 .569 2.77l4.046 2.67a2 2 0 0 0 2.771-.57l1.277-1.936a2 2 0 0 0-.568-2.77l-4.047-2.67Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M27.687 8.949C12.422 8.949 0 21.145 0 36.139 0 51.134 12.422 63.33 27.687 63.33s27.687-12.196 27.687-27.19c0-14.995-12.422-27.191-27.687-27.191Zm0 52.57c-14.248 0-25.84-11.386-25.84-25.38s11.592-25.38 25.84-25.38 25.84 11.386 25.84 25.38-11.592 25.38-25.84 25.38Z"
    />
    <path
      fill="#26A3DD"
      d="M28.55 19.271a.964.964 0 0 0 .675-.274.93.93 0 0 0 .28-.664v-3.391a.93.93 0 0 0-.28-.663.964.964 0 0 0-1.35 0 .93.93 0 0 0-.28.663v3.391c0 .52.428.938.955.938ZM9.557 34.354H6.103a.964.964 0 0 0-.675.275.93.93 0 0 0 0 1.326c.18.176.422.274.675.274h3.454a.97.97 0 0 0 .675-.274.939.939 0 0 0 .28-.663.925.925 0 0 0-.28-.663.956.956 0 0 0-.675-.275Zm35.305.938c0 .518.428.937.954.937h3.454a.97.97 0 0 0 .675-.274.937.937 0 0 0 .28-.663.923.923 0 0 0-.28-.663.955.955 0 0 0-.675-.275h-3.454a.964.964 0 0 0-.675.275.93.93 0 0 0-.28.663Zm-29.996-9.11a.965.965 0 0 0 .53-.157.94.94 0 0 0 .353-.42.92.92 0 0 0-.208-1.023l-2.72-2.672a.957.957 0 0 0-.674-.274.97.97 0 0 0-.674.274.934.934 0 0 0-.28.662.923.923 0 0 0 .28.662l2.72 2.671a.94.94 0 0 0 .673.277Zm28.172-3.794a.934.934 0 0 0 .28-.662.922.922 0 0 0-.28-.662.956.956 0 0 0-.674-.275.967.967 0 0 0-.674.275l-2.72 2.67a.936.936 0 0 0-.279.663.923.923 0 0 0 .28.663.954.954 0 0 0 .675.274.969.969 0 0 0 .675-.275l2.717-2.67ZM14.925 45.651l-2.59 2.544a.937.937 0 0 0-.28.663.921.921 0 0 0 .28.662.955.955 0 0 0 .675.274.969.969 0 0 0 .675-.274l2.59-2.544a.936.936 0 0 0 .28-.663.924.924 0 0 0-.28-.663.957.957 0 0 0-.676-.273.97.97 0 0 0-.674.274Zm18.805 4.055H21.643c-1.535-.058-2.65 1.036-2.65 2.544v1.623c0 1.523 1.164 2.718 2.65 2.616H33.73c1.485.102 2.65-1.093 2.65-2.616V52.25c0-1.508-1.115-2.602-2.65-2.544Zm.803 4.167c0 .436-.252.905-.803.963H21.643c-.552-.058-.803-.53-.803-.042V53.17c0-1.423.292-1.711.803-1.77H33.73c.51.059.803.347.803.849v1.623Zm-6.847-13.21a4.61 4.61 0 0 0 3.255-1.325 4.465 4.465 0 0 0 .587-5.69l4.581-4.499a.898.898 0 0 0 0-1.282.931.931 0 0 0-1.305 0l-4.586 4.504c-1.77-1.11-4.27-.92-5.786.57a4.501 4.501 0 0 0-1.257 2.316 4.451 4.451 0 0 0 .263 2.61 4.546 4.546 0 0 0 1.693 2.03 4.67 4.67 0 0 0 2.555.765Zm-1.626-6.121a2.303 2.303 0 0 1 1.627-.663 2.31 2.31 0 0 1 1.628.663 2.234 2.234 0 0 1 0 3.197c-.869.854-2.385.854-3.255 0a2.242 2.242 0 0 1-.673-1.599c0-.599.242-1.174.673-1.598Z"
    />
    <path
      fill="#D3ECF8"
      d="M64 51.782c0 6.378-5.17 11.548-11.548 11.548s-11.549-5.17-11.549-11.548 5.17-11.548 11.549-11.548C58.83 40.234 64 45.404 64 51.782Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M52.452 61.58c5.411 0 9.798-4.386 9.798-9.798 0-5.411-4.387-9.798-9.798-9.798-5.412 0-9.799 4.387-9.799 9.798 0 5.412 4.387 9.798 9.799 9.798Zm0 1.75C58.83 63.33 64 58.16 64 51.782s-5.17-11.548-11.548-11.548-11.549 5.17-11.549 11.548 5.17 11.548 11.549 11.548Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.3}
      d="M58.066 48.102a.645.645 0 0 1 0 .912l-7.093 7.093a.645.645 0 0 1-.912 0l-3.224-3.224a.645.645 0 0 1 .912-.912l2.768 2.768 6.637-6.637a.645.645 0 0 1 .912 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgStopwatch;
